import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

import { Providers } from './src/components/Layout/Providers';
import { analyticsConfig } from './src/config/analytics';

import type { FC, ReactElement } from 'react';

import type { GatsbyBrowser } from 'gatsby';

/** This wraps ALL of Gatsby with these providers. */
const RootWrapper: FC<{ element: ReactElement }> = ({ element }) => {
  // Initialize Google Tag Manager on client-side
  useEffect(() => {
    const gtmId = analyticsConfig.googleAnalytics.tagManagerContainer;
    if (gtmId) {
      TagManager.initialize({
        gtmId,
      });
    }
  }, []);

  return <Providers>{element}</Providers>;
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
  <RootWrapper element={element} />
);
